import React from 'react';
import PillarPageLayout from '../components/PillarPageLayout';

const ProtectPage: React.FC = () => {
  const diagram = (
    <>
      <p className="font-semibold text-slate-700 mb-5 text-center text-sm">Without Megadish</p>
      <div className="flex items-center justify-center gap-3 my-3 flex-wrap">
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-white text-slate-700 border border-slate-300">
          Your Laptop
        </div>
        <span className="text-slate-400">→</span>
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-red-100 text-red-600 border border-red-300">
          Public WiFi
        </div>
        <span className="text-slate-400">←</span>
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-red-100 text-red-600 border border-red-300">
          Hackers
        </div>
      </div>
      <p className="text-xs text-slate-500 text-center italic mt-2">
        Your device visible to everyone on the network
      </p>
      
      <hr className="border-t border-dashed border-slate-300 my-7" />
      
      <p className="font-semibold text-slate-700 mb-5 text-center text-sm">With Megadish</p>
      <div className="flex items-center justify-center gap-3 my-3 flex-wrap">
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-white text-slate-700 border border-slate-300">
          Your Laptop
        </div>
        <span className="text-slate-400">→</span>
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-green-100 text-green-600 border border-green-300">
          Megadish
        </div>
        <span className="text-slate-400">→</span>
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-red-100 text-red-600 border border-red-300">
          Public WiFi
        </div>
      </div>
      <p className="text-xs text-slate-500 text-center italic mt-2">
        Your device hidden behind Megadish's private network
      </p>
    </>
  );

  const explanation = (
    <>
      <h3 className="text-xl font-semibold text-slate-800 mb-4">Why security matters</h3>
      <p className="text-slate-600 mb-4 leading-relaxed">
        When you connect to public WiFi, your device joins a network with every other 
        person in that hotel, café, or airport. Skilled hackers can see your device, 
        intercept your traffic, and attempt to break in.
      </p>
      <p className="text-slate-600 leading-relaxed">
        Megadish sits between you and them. Your devices connect only to Megadish's 
        private network — they never touch the public WiFi directly.
      </p>
    </>
  );

  return (
    <PillarPageLayout
      icon="🔒"
      title="Protect"
      subtitle="Your own private network on any public WiFi"
      color="green"
      diagram={diagram}
      explanation={explanation}
      benefits={[
        'Your devices invisible to others on the public network',
        'Extra NAT layer blocks incoming attacks',
        'No operating system to hack — just a simple microcontroller',
        'No data collected, no cloud connection, nothing to exploit',
      ]}
      scenarios={[
        { emoji: '💼', label: 'Business travel abroad' },
        { emoji: '🌏', label: 'Cafés in countries with surveillance' },
        { emoji: '✈️', label: 'Airport WiFi' },
        { emoji: '🏨', label: 'Hotel networks' },
      ]}
    />
  );
};

export default ProtectPage;
